import * as authAction from "./auth";

export const AUTH_ACTIONS = authAction.ACTIONS;